import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e23fe28e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "information-modal" }
const _hoisted_2 = { class: "mt-4" }
const _hoisted_3 = {
  key: 0,
  class: "d-flex justify-content-center mb-4"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 0,
  class: "d-flex flex-column flex-md-row align-items-center justify-content-between"
}
const _hoisted_6 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AsahiTypography = _resolveComponent("AsahiTypography")!
  const _component_AsahiButton = _resolveComponent("AsahiButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["d-flex", {'justify-content-between': _ctx.title, 'justify-content-end': !_ctx.title || _ctx.withIcon}])
    }, [
      (_ctx.title)
        ? (_openBlock(), _createBlock(_component_AsahiTypography, {
            key: 0,
            type: "body-1-bold"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.withIcon? '' : _ctx.title), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        type: "button",
        class: "btn-close",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onCancel())),
        "aria-label": "Close"
      })
    ], 2),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.icon)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("img", {
              src: _ctx.icon,
              alt: "icon"
            }, null, 8, _hoisted_4)
          ]))
        : _createCommentVNode("", true),
      (_ctx.title && _ctx.withIcon)
        ? (_openBlock(), _createBlock(_component_AsahiTypography, {
            key: 1,
            type: "body-1-bold d-flex justify-content-center",
            class: "d-flex justify-content-center"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(!_ctx.withIcon? '' : _ctx.title), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.message)
        ? (_openBlock(), _createBlock(_component_AsahiTypography, {
            key: 2,
            type: "body-2",
            class: _normalizeClass(["d-block mb-3", {'d-flex justify-content-center mt-2': _ctx.withIcon}])
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.message), 1)
            ]),
            _: 1
          }, 8, ["class"]))
        : _createCommentVNode("", true),
      (_ctx.subMessage)
        ? (_openBlock(), _createBlock(_component_AsahiTypography, {
            key: 3,
            type: "body-1-bold",
            class: "d-block mb-3 mt-3"
          }, {
            default: _withCtx(() => [
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subMessage.split('\n'), (line) => {
                  return (_openBlock(), _createElementBlock("li", { key: line }, _toDisplayString(line), 1))
                }), 128))
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    (_ctx.cancel)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", null, [
            _createVNode(_component_AsahiButton, {
              type: "secondary",
              onClick: _cache[1] || (_cache[1] = () => _ctx.onCancel()),
              class: "mt-4 min-button-width"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.cancel), 1)
              ]),
              _: 1
            })
          ]),
          (_ctx.confirm)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_component_AsahiButton, {
                  type: "primary",
                  onClick: _cache[2] || (_cache[2] = () => _ctx.onConfirm()),
                  class: "mt-4 min-button-width"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.confirm), 1)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["d-flex", [_ctx.isMobile ? 'w-100 justify-content-center': 'justify-content-end', {'justify-content-center':_ctx.withIcon}]])
        }, [
          (_ctx.confirm && _ctx.withIcon)
            ? (_openBlock(), _createBlock(_component_AsahiButton, {
                key: 0,
                type: "primary-gold",
                onClick: _cache[3] || (_cache[3] = () => _ctx.onConfirm()),
                class: _normalizeClass(["mt-4", {'w-100': _ctx.isMobile, 'min-button-width': !_ctx.isMobile}])
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.confirm), 1)
                ]),
                _: 1
              }, 8, ["class"]))
            : _createCommentVNode("", true),
          (_ctx.confirm && !_ctx.withIcon)
            ? (_openBlock(), _createBlock(_component_AsahiButton, {
                key: 1,
                type: "primary",
                onClick: _cache[4] || (_cache[4] = () => _ctx.onConfirm()),
                class: _normalizeClass(["mt-4", {'w-100': _ctx.isMobile, 'min-button-width': !_ctx.isMobile}])
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.confirm), 1)
                ]),
                _: 1
              }, 8, ["class"]))
            : _createCommentVNode("", true)
        ], 2))
  ]))
}